import { Paragraph } from '@silverrailtech/srtlibrary';
import styled from 'styled-components';

export const StyledOption = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
`;

export const StyledParagraph = styled(Paragraph)`
	width: 100%;
	padding: 8px 16px;
	border-radius: 4px;
	background: #f8f9fa;
	font-size: 13px;
	font-style: normal;
	font-weight: 300;
	line-height: 19px;
`;
